import React, { useCallback } from 'react';
import styled from 'styled-components';
import { LFC } from '../../../Legacy';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { DropButton } from '../../../ui/DropButton';
import { useResolve } from '../../Container';
import { Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { Colors, Grid } from './../../../ui';
import { meetingBreak } from './MeetingCommands';

const opt = (value: number) => ({ label: value > 120 ? 'No Limit' : `${value} mins`, value });
type Option = ReturnType<typeof opt>;

const options: Option[] = [
    opt(5),
    opt(10),
    opt(15),
    opt(20),
    opt(30),
    opt(60),
    opt(90),
    opt(120),
    opt(999),
];

const ButtonGrid = styled(Grid)`
    font-size: 1.25rem;
    font-weight: 450;
`;

export const SetupCoffeeBreakInlineView: LFC<{ onNavigate: (path: string) => void }> = ({ onNavigate }) => {

    const dispatch = useResolve(CommandDispatcher);

    const onSelect = useCallback((value: number) => {
        onNavigate('exit');
        dispatch(meetingBreak, [value * 60000]);
    }, [onNavigate]);

    return <Flexer height="100%" padding="1" gap=".5" flex="column" center>
        <Flexer gap=".275" flex="row" center>
            <Flexer padding="0 0 .75 0">
                <Icon src="deqo://icons/meeting/coffee" size="2.5" />
            </Flexer>
            <Title size="lg" flush>Coffee Break</Title>
        </Flexer>
        <Flexer flex="column" center>
            <Copy flush>
                Please select how long you would like to break for:
            </Copy>
            <Copy flush size=".75" color={Colors.textLight}>
                Selection only affects indicative timer, meeting must still be resumed manually.
            </Copy>
        </Flexer>
        <Flexer padding=".5 0">
            <ButtonGrid columns="1fr 1fr 1fr" columnGap=".5rem" rowGap=".5rem">
                {options.map(o =>
                    <DropButton key={o.label} onClick={() => onSelect(o.value)} padding=".5">
                        <span>{o.label}</span>
                    </DropButton>
                )}
            </ButtonGrid>
        </Flexer>
        <Flexer>
            <DropButton padding=".125 .375" onClick={() => onNavigate('menu')}>
                <Icon src="deqo://icons/hero/arrow-sm-left" size="1.5" />
                <Title weight="400" flush>Go Back</Title>
            </DropButton>
        </Flexer>
    </Flexer>;
};
